/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyMember = {
  properties: {
    cpf: {
      type: 'string',
    },
    cnpj: {
      type: 'string',
    },
    name: {
      type: 'string',
      isRequired: true,
    },
    inclusionDate: {
      type: 'number',
      isRequired: true,
    },
    qualification: {
      type: 'string',
      isRequired: true,
    },
    type: {
      type: 'string',
      isRequired: true,
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
  },
} as const;
